module.exports = "/_next/static/images/a9c9367aee7089ea0136c184b0cd3162-hand-coin.svg";